import React, { useContext, useEffect, useState } from 'react';
import { PeFilterContext } from '../../Contexts/PeFilterContext';
import MultiSelectEntity from '../RefineSearch/MultiSelectEntity';
import Popup from '../Common/Popup';
import Constants from '../../Constants';
import { FaInfoCircle } from 'react-icons/fa';
import { Tooltip } from 'antd';
import DefinitionModal from '../DefinitionModal';

function ExitDealTypeFilter({ ExitDealTypeOptions, setExitDealTypeOptions, customPathname, dataPath, heading = "Deal Type", isPopupOpen, setIsPopupOpen }) {
    const { refineSearchFilters, dealTypeFilterResponse } = useContext(PeFilterContext);
    const [internalPopupOpen, setInternalPopupOpen] = useState(false);
    
    // Use centralized state if provided, otherwise fall back to internal state
    const popupOpen = isPopupOpen !== undefined ? isPopupOpen : internalPopupOpen;
    const setPopupOpen = setIsPopupOpen !== undefined ? setIsPopupOpen : setInternalPopupOpen;

    useEffect(() => {
        const dealTypeIds = refineSearchFilters[customPathname]?.dealType?.map(value => value.id) ?? [];
        setExitDealTypeOptions(dealTypeFilterResponse[dataPath]?.map(type => ({ 
            ...type, 
            isChecked: dealTypeIds.includes(type.id) 
        })) ?? []);
    }, [dealTypeFilterResponse, customPathname, refineSearchFilters, dataPath, setExitDealTypeOptions]);

    const handleChange = (e) => {
        const { id, checked } = e.target;
        const updatedOptions = ExitDealTypeOptions.map(type =>
            type.id === parseInt(id) ? { ...type, isChecked: checked } : type
        );
        setExitDealTypeOptions(updatedOptions);
    };

    const selectedCount = ExitDealTypeOptions?.filter(option => option.isChecked)?.length ?? 0;

    const [showDefModal, setShowDefModal] = useState(false);
    
    const openModal = (e) => {
        e.stopPropagation(); // Prevent button click from toggling popup
        setShowDefModal(true);
    }
    
    const closeModal = () => {
        setShowDefModal(false);
    }

    return (
        <div className="relative w-full md:inline-block">
            <button
                type="button"
                className="h-10 rounded-md px-4 py-1 text-gray-500 hover:bg-gray-100  text-sm shadow-md border border-gray-300 text-left flex items-center justify-between w-full md:w-[90%]"
                onClick={() => setPopupOpen(!popupOpen)}
            >
                <span className="truncate pr-2 flex items-center gap-2">
                    {heading}
                    <Tooltip title='Definitions'>
                        <FaInfoCircle 
                            size={12} 
                            color="grey" 
                            className="cursor-pointer flex-shrink-0" 
                            onClick={openModal}
                        />
                    </Tooltip>
                    {ExitDealTypeOptions?.length > 0 && (
                        <span className="opacity-60 ml-2 text-xs text-ellipsis">e.g. {ExitDealTypeOptions.slice(0,2).map(item => item.name).join(', ')}</span>
                    )}
                </span>
                <div className="flex items-center gap-2 flex-shrink-0">
                    {selectedCount > 0 && (
                        <span className="bg-white rounded-full px-2 py-0.5 text-xs font-medium border border-gray-400">
                            {selectedCount}
                        </span>
                    )}
                    <span className={`transition-transform duration-200 text-xl font-semibold ${popupOpen ? 'rotate-[270deg]' : 'rotate-90'}`}>
                        ›
                    </span>
                </div>
            </button>

            {popupOpen && (
                <Popup onClose={() => setPopupOpen(false)}>
                    <div className="p-2">
                        <MultiSelectEntity
                            handleEntityChange={handleChange}
                            primaryEntity={ExitDealTypeOptions || []}
                        />
                    </div>
                </Popup>
            )}
            {showDefModal && <DefinitionModal label={heading} definitionInfo={Constants.dealType} onClose={closeModal}/>}
        </div>
    );
}

export default ExitDealTypeFilter